export default () => {
  let env = process.env.NODE_ENV;
  let url = "";
  switch (env) {
    case "dev":
      url = "http://localhost:4000";
      break;

    case "production":
      url = "https://managment.unabase.es";
      break;
    default:
      url = "http://localhost:4000";
      break;
  }
  return url;
};
